import {
  Button,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  Typography,
  Box,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import Title from "../../ui/Title";
import { StyledInput } from "../../ui/StyledInput";
import { ChangeEvent, useEffect, useState } from "react";
import { OrderFormType } from "./AddOrder";
import { StyledButton } from "../../ui/StyledButton";

const OrderDetailsForm = ({
  label,
  handleNext,
  handleBack,
  finalForm,
  setFinalForm,
}: {
  label: string;
  handleNext: () => void;
  handleBack: () => void;
  setFinalForm: (finalForm: any) => void;
  finalForm: OrderFormType;
}) => {
  const [isCod, setIsCode] = useState<boolean>(false);

  const [canNext, setCanNext] = useState(true);

  const onlyNumber = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    limit: number
  ) => event.target.value.replace(/[^0-9]/g, "").slice(0, limit);

  const handleNumberChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => {
    event.target.value = onlyNumber(event, 10);

    handleInputChange(event, field);
  };

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => {
    const newFormData = { ...finalForm };

    newFormData[field] = e.target.value;

    setFinalForm(newFormData);
  };

  const handleBooleanChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => {
    const newFormData = { ...finalForm };
    let type = e.target.value;
    if (type === "true") {
      newFormData[field] = true;
      setIsCode(true);
    } else {
      newFormData[field] = false;
      setIsCode(false);
    }
    setFinalForm(newFormData);
  };

  const handleSelectChange = (e: SelectChangeEvent<string>) => {
    const newFormData = { ...finalForm };
    let type = e.target.value;

    newFormData.freight_on_carrier = type;

    setFinalForm(newFormData);
  };

  const validateForm = () => {
    let canNext = true;

    if (finalForm.invoice_value.trim() !== "") {
      canNext = false;
    }

    if (isCod) {
      canNext = true;
      if (finalForm.cod_amount.trim() !== "") {
        canNext = false;
      }
    }

    setCanNext(canNext);
  };

  useEffect(() => {
    validateForm();
  }, [finalForm, isCod]);

  return (
    <Box>
      <Title title={`${label}`} />
      <Box
        sx={{
          margin: "10px 0",
        }}
      >
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <FormLabel>
                <Typography fontSize={12}>Order ID</Typography>
              </FormLabel>
              <StyledInput
                value={finalForm.order_id}
                onChange={(e) => handleInputChange(e, "order_id")}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormLabel>
                <Typography fontSize={12}>Invoice Value</Typography>
              </FormLabel>
              <StyledInput
                placeholder="Invoice Value"
                value={finalForm.invoice_value}
                onChange={(e) => handleNumberChange(e, "invoice_value")}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormLabel>
                <Typography fontSize={12}>Invoice Number</Typography>
              </FormLabel>
              <StyledInput
                placeholder="Invoice Number"
                value={finalForm.invoice_number}
                onChange={(e) => handleInputChange(e, "invoice_number")}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormLabel>
                <Typography fontSize={12}>Ewaybill Number</Typography>
              </FormLabel>
              <StyledInput
                placeholder="Ewaybil Number"
                value={finalForm.ewaybill_number}
                onChange={(e) => handleInputChange(e, "ewaybill_number")}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl sx={{ minWidth: 150 }} size="small">
                <FormLabel>
                  <Typography fontSize={12}>Insurance</Typography>
                </FormLabel>
                <Select
                  sx={{
                    borderRadius: "16px",
                    background: "#fff",
                    boxShadow:
                      "-1px -1px 4px 0px rgb(255, 255, 255), 2px 2px 6px 0px rgba(0, 0, 0, 0.2) !important",
                  }}
                  value={finalForm.freight_on_carrier}
                  onChange={(e) => handleSelectChange(e)}
                >
                  <MenuItem value={"NI"}>No Issurance</MenuItem>
                  <MenuItem value={"CI"}>Carrier Issurance</MenuItem>
                  <MenuItem value={"OI"}>Own Issurance</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography>Payment Details</Typography>
              <Typography fontSize={10}>
                Select mode of payment that your buyer has chosen for the order
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <RadioGroup
                value={finalForm.cod}
                name="radio-buttons-group"
                onChange={(e) => handleBooleanChange(e, "cod")}
              >
                <Stack direction={"row"}>
                  <Stack
                    direction={"row"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <Radio value={false} size="small" />
                    <Typography fontSize={12}>Prepaid</Typography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <Radio value={true} size="small" />
                    <Typography fontSize={12}>Cash on Delivery</Typography>
                  </Stack>
                </Stack>
              </RadioGroup>
            </Grid>
            <Grid item xs={12}>
              {isCod && (
                <Grid item xs={12} sm={6} md={3}>
                  <FormLabel>
                    <Typography fontSize={12}>Cod Amount</Typography>
                  </FormLabel>
                  <StyledInput
                    placeholder="Cod Amount"
                    value={finalForm.cod_amount}
                    onChange={(e) => handleNumberChange(e, "cod_amount")}
                    fullWidth
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Stack
        flexDirection={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        marginTop={2}
        columnGap={2}
      >
        <StyledButton variant="contained" onClick={handleBack}>
          Back
        </StyledButton>
        <StyledButton
          disabled={canNext}
          variant="contained"
          onClick={handleNext}
        >
          Next
        </StyledButton>
      </Stack>
    </Box>
  );
};

export default OrderDetailsForm;
